import $ from "jquery";
import React from 'react';
import { injectIntl, intlShape } from "react-intl";
import Alert from "../../common/Alert";
import Propertii from "../../common/Propertii";
import Spinner from "../../common/Spinner";
import TransactionList from "../../common/Transactions";

class Transactions extends Propertii {

    /**
     * Initialize the component.
     *
     * @param props - The properties of the component.
     */
    constructor(props) {

        super(props);

        this.state = {
            validationList: [],
        };
    }

    /**
     * Render the component.
     *
     * @returns {*} - The create property component for landlords.
     */
    render() {

        $(function() {
            $('[data-toggle="tooltip"]').tooltip()
        });

        let hasMakePaymentPermission = this.props.userSession?.sessionRole?.type !== 'TYPE_MANAGER' ||
            (this.props.userSession?.sessionRole?.roles?.includes('PRIMARY_MANAGER') ||
                this.props.userSession?.sessionRole?.roles?.includes('SUPPORT_MANAGER') ||
                this.props.userSession?.sessionRole?.roles?.includes('PROPERTY_MANAGER') ||
                this.props.userSession?.sessionRole?.roles?.includes('FINANCE_MANAGER'));

        return(
            <React.Fragment>

                <Spinner visible={this.state.spinner} />

                <Alert validationList={this.state.validationList} />

                <TransactionList billingAccountId={this.props.match.params.propertyLeaseId}
                                 userId={this.props.userId}
                                 makePayment={hasMakePaymentPermission} parent={this}
                                 textSearchPlaceholderOverride = "Search Tenants Transactions"
                                 makePaymentPath={`/manager/tenants/${this.props.match.params.propertyLeaseId}/payment`}
                                 userType="TYPE_MANAGER" />

            </React.Fragment>
        )
    };
}

Transactions.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Transactions);